module.exports = __webpack_public_path__ + "media/bootstrap-icons/credit-card-f00e8cc7.svg";